import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export const InfoSection = () => {
  return <div className="space-y-16 py-8" data-id="element-349">
      {/* Guarantee */}
      <FadeIn data-id="element-350">
        <section className="bg-slate-900 border border-slate-700 rounded-2xl p-8 sm:p-10 text-center relative overflow-hidden" data-id="element-351">
          <div className="absolute top-0 left-0 w-full h-1 bg-amber-500" data-id="element-352"></div>
          <div className="text-5xl mb-4" data-id="element-353">🛡️</div>
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-6" data-id="element-354">
            La Garantía de las 7 Noches
          </h2>
          <p className="text-lg text-slate-300 leading-relaxed mb-6" data-id="element-355">
            Duerme 7 noches con el protocolo. Si no sientes una diferencia real,
            te devolvemos cada centavo. Sin preguntas. Sin formularios
            complicados. Sin drama.
          </p>
          <p className="text-lg text-white font-medium" data-id="element-356">
            Estamos tan seguros de que este protocolo funciona que asumimos todo
            el riesgo. Tú no tienes nada que perder excepto el ardor.
          </p>
        </section>
      </FadeIn>

      {/* Audience */}
      <FadeIn data-id="element-357">
        <section className="grid md:grid-cols-2 gap-8" data-id="element-358">
          <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-6 sm:p-8" data-id="element-359">
            <h3 className="text-xl font-bold text-white mb-6 border-b border-slate-800 pb-4" data-id="element-360">
              ¿Para quién ES este protocolo?
            </h3>
            <ul className="space-y-4" data-id="element-361">
              {['Hombres y mujeres de 35 a 60 años que despiertan con ardor o tos nocturna.', 'Personas que llevan meses o años dependiendo de omeprazol o antiácidos diarios.', 'Quienes sienten que el reflujo está destruyendo su sueño, su humor y su productividad.', "Personas que han probado 'de todo' y siguen sufriendo cada noche.", 'Quienes quieren una solución mecánica y natural sin depender de fármacos de por vida.'].map((text, i) => <li key={i} className="flex gap-3 text-slate-300" data-id="element-362">
                  <span className="text-green-500 flex-shrink-0" data-id="element-363">✔️</span>
                  <span data-id="element-364">{text}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-6 sm:p-8" data-id="element-365">
            <h3 className="text-xl font-bold text-white mb-6 border-b border-slate-800 pb-4" data-id="element-366">
              ¿Para quién NO es?
            </h3>
            <ul className="space-y-4" data-id="element-367">
              {['Personas que buscan una solución sin cambiar absolutamente ningún hábito nocturno.', 'Quienes tienen condiciones médicas graves diagnosticadas que requieren intervención quirúrgica inmediata.', 'Personas que no están dispuestas a aplicar el protocolo durante al menos 7 noches consecutivas.'].map((text, i) => <li key={i} className="flex gap-3 text-slate-300" data-id="element-368">
                  <span className="text-red-500 flex-shrink-0" data-id="element-369">❌</span>
                  <span data-id="element-370">{text}</span>
                </li>)}
            </ul>
          </div>
        </section>
      </FadeIn>

      {/* Steps */}
      <FadeIn data-id="element-371">
        <section data-id="element-372">
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-8 text-center" data-id="element-373">
            Cómo funciona en 3 pasos:
          </h2>
          <div className="space-y-6" data-id="element-374">
            {[{
            step: 'Paso 1 — HOY (5 minutos)',
            desc: 'Descarga el mapa, lee la introducción y completa la Auditoría de Disparadores. Sabrás exactamente qué está causando tu reflujo esta misma noche.'
          }, {
            step: 'Paso 2 — ESTA NOCHE',
            desc: 'Implementa el Protocolo 3-2-1 y ajusta la inclinación de tu posición de descanso siguiendo la Guía de Ingeniería del Descanso. Sin compras adicionales necesarias.'
          }, {
            step: 'Paso 3 — EN 7 DÍAS',
            desc: 'Despierta sin dolor, sin ardor y con la energía que el reflujo te ha estado robando cada mañana.'
          }].map((item, i) => <div key={i} className="bg-slate-900 border border-slate-800 rounded-xl p-6 flex flex-col sm:flex-row gap-4 sm:gap-6 items-start" data-id="element-375">
                <div className="bg-blue-900/50 text-blue-400 rounded-full w-12 h-12 flex items-center justify-center flex-shrink-0 font-bold text-xl border border-blue-800/50" data-id="element-376">
                  {i + 1}
                </div>
                <div data-id="element-377">
                  <h4 className="text-lg font-bold text-white mb-2 flex items-center gap-2" data-id="element-378">
                    <span className="text-blue-500 hidden sm:inline" data-id="element-379">🔵</span>{' '}
                    {item.step}
                  </h4>
                  <p className="text-slate-300 leading-relaxed" data-id="element-380">{item.desc}</p>
                </div>
              </div>)}
          </div>
        </section>
      </FadeIn>

      {/* Why it works */}
      <FadeIn data-id="element-381">
        <section className="bg-slate-900 border border-slate-800 rounded-2xl p-8 sm:p-10 text-center" data-id="element-382">
          <h2 className="text-2xl font-bold text-white mb-6" data-id="element-383">
            ¿Por qué funciona cuando todo lo demás ha fallado?
          </h2>
          <p className="text-lg text-slate-300 leading-relaxed mb-6" data-id="element-384">
            Porque ataca el problema desde la raíz mecánica, no desde el síntoma
            químico. Si el estómago llega vacío a la cama y el esófago está
            físicamente elevado por encima del nivel del ácido, el reflujo es
            anatómicamente improbable.
          </p>
          <p className="text-xl font-bold text-amber-500" data-id="element-385">
            No es magia. Es física aplicada a tu cuerpo.
          </p>
        </section>
      </FadeIn>
    </div>;
};